function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTable, useResizeColumns, useBlockLayout, useSortBy } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import { Checkbox } from '@material-ui/core';
const TableDiv = styled.div`
  overflow: auto;
  border: 1px solid #f2f3f3;
  border-spacing: 0;

  padding: 0 1px;
  .table {
    display: inline-block;
    margin-bottom: 0px;

    .table-buttons {
      display: none;
      position: absolute;
      background: #eff3f8;
      padding: 5px;
      right: 127px;
      align-items: center;
      height: 38px;
      button {
        background: #eff3f8;
        border: none;
        border-radius: 50%;
        font-size: 14px;
        color: #1462a6;
        height: 38px;
        width: 38px;
        opacity: 0.7;
        &:hover {
          background: #cddeec;
          opacity: 1;
        }
      }
    }

    .sort-icons {
      font-size: 19px;
      display: flex;
      flex-direction: column;
      > * {
        margin: -8px 0;
        opacity: 0.2;
      }
      > .selected {
        opacity: 1;
      }
    }

    .ellipsis {
      margin-top: ${props => props.isCheckList === true ? '3px;' : '0'};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: auto;
      display: inline-block;
    }

    .tr {
      height: 38px;
      min-width: 100% !important;
      border-bottom: 1px solid #f2f3f3;

      &:last-child {
        border-bottom: none;
      }
    }

    .th,
    .td {
      margin: 0;
      padding: 0 10px;
      font-family: 'OpenSans-Regular';
      font-size: 14px;
      color: #525252;
      line-height: 18px;
      position: relative;
      align-items: center !important;
      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        background: #a0a0a0;
        box-shadow: 0px 0px 2px f2f3f3;
        width: 1px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;
        touch-action: none;

        &.isResizing {
          background: gray;
        }
      }
    }

    .td {
      color: #525252;
      line-height: 18px;
    }
    .th {
      justify-content: space-between !important;
    }
    .th,
    .thead {
      color: #161616;
      background: #f2f3f3;
      > .tr:hover {
        background: #f2f3f3;
      }
    }

    .tr:hover {
      background: #eff3f8;
      > .table-buttons {
        display: inline-flex;
      }
    }

    .MuiCheckbox-colorPrimary.Mui-checked {
      color: #1661a6;
      background: #eff3f8;
      border-radius: 0px;
    }

    .selected {
      background: #eff3f8;
    }
  }
`;
const StyledTr = styled.div`
  background: ${props => props.isItemSelected ? '#EFF3F8' : '#fff'};
`;
const StyledCheckBox = styled.div`
  && {
    margin-right: 15px;
    .MuiCheckbox-root {
      padding: 1px;
    }
  }
`;

const Table = props => {
  const {
    columns,
    data,
    handleSort,
    buttons,
    isCheckList,
    checkListClick,
    order,
    sortOrderBy
  } = props;
  const tableRef = useRef(null);
  const [tableWidth, setTableWidth] = useState();
  const [updatedCoulumns, setUpdatedColumns] = useState(columns);
  const defaultColumn = React.useMemo(() => ({
    minWidth: 50
  }), []);
  useEffect(() => {
    if (tableRef.current) {
      setTableWidth(tableRef.current.parentElement.offsetWidth - 5);
    }
  }, [tableRef]);
  useEffect(() => {
    const setColumnWidths = () => {
      let totalColumnWidth = 0;
      columns.forEach(column => totalColumnWidth += column.width || defaultColumn.width);

      if (tableWidth > totalColumnWidth) {
        setUpdatedColumns(columns.map(column => ({ ...column,
          width: (column.width || defaultColumn.width) / totalColumnWidth * tableWidth
        })));
      } else {
        setUpdatedColumns(columns);
      }
    };

    setColumnWidths();
  }, [tableWidth, columns]);
  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns: updatedCoulumns,
    data,
    defaultColumn
  }, useResizeColumns, useBlockLayout, useSortBy);
  const handleSortBy = useCallback(sortColumn => {
    handleSort(sortColumn);
  });
  const checkList = useCallback((event, row) => {
    checkListClick(event, row);
  });
  return /*#__PURE__*/React.createElement(TableDiv, {
    isCheckList: isCheckList
  }, /*#__PURE__*/React.createElement("div", _extends({}, getTableProps(), {
    className: "table",
    ref: tableRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "thead"
  }, headerGroups.map((headerGroup, index) => /*#__PURE__*/React.createElement("div", _extends({
    key: index
  }, headerGroup.getHeaderGroupProps({}), {
    className: "tr"
  }), headerGroup.headers.map((column, index) => /*#__PURE__*/React.createElement("div", _extends({
    key: index
  }, column.getHeaderProps(headerProps), {
    className: "th",
    onClick: () => handleSortBy(column)
  }), /*#__PURE__*/React.createElement("div", {
    className: "ellipsis"
  }, column.render('Header')), column.Header !== '' && column.id === sortOrderBy && /*#__PURE__*/React.createElement("div", {
    className: "sort-icons"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: order === 'asc' ? 'selected' : '',
    icon: faSortUp
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: order === 'asc' ? '' : 'selected',
    icon: faSortDown
  })), column.canResize && /*#__PURE__*/React.createElement("div", _extends({}, column.getResizerProps(), {
    onClick: e => {
      e.stopPropagation();
    },
    className: `resizer ${column.isResizing ? 'isResizing' : ''}`
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "tbody"
  }, rows.map((row, index) => {
    const isItemSelected = row.original.checked;
    const labelId = `enhanced-table-checkbox-${index}`;
    prepareRow(row);
    return /*#__PURE__*/React.createElement(StyledTr, _extends({
      key: index
    }, row.getRowProps(), {
      className: "tr",
      isItemSelected: isItemSelected
    }), /*#__PURE__*/React.createElement(React.Fragment, null, row.cells.map((cell, index) => {
      return /*#__PURE__*/React.createElement("div", _extends({
        key: index
      }, cell.getCellProps(cellProps), {
        className: "td",
        isCheckList: isCheckList
      }), /*#__PURE__*/React.createElement(React.Fragment, null, index == 0 && isCheckList ? /*#__PURE__*/React.createElement(StyledCheckBox, null, /*#__PURE__*/React.createElement(Checkbox, {
        checked: isItemSelected,
        color: "primary",
        onChange: () => checkList(event, row),
        inputProps: {
          'aria-labelledby': {
            labelId
          }
        }
      })) : null), /*#__PURE__*/React.createElement(Tooltip, {
        key: cell.render('Cell'),
        title: cell.render('Cell'),
        arrow: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "ellipsis"
      }, cell.render('Cell'))));
    }), buttons && /*#__PURE__*/React.createElement("div", {
      className: "table-buttons"
    }, buttons(index))));
  }))));
};

const headerProps = (props, {
  column
}) => getStyles(props, column.align);

const cellProps = (props, {
  cell
}) => getStyles(props, cell.column.align);

const getStyles = (props, align = 'left') => [props, {
  style: {
    justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
    alignItems: 'flex-start',
    display: 'flex'
  }
}];

export default Table;